import React from 'react';
import TopNav from '@hig/top-nav';
import logo from '../../static/logo.png';

const PdaLogo = () => {
  return (
    <div className="pda-header-image">
      <img
        src={logo}
        width="165"
        height="28"
        alt="logo"
      />
   </div>
  )
}

const Logo = ({ onBeforeNavigate }) => (
  <TopNav.Logo
    label="Autodesk FrontDoors"
    title="Autodesk FrontDoors"
  >
    <PdaLogo />
  </ TopNav.Logo>
);

export default Logo;
